module.exports = require('./editorScript').storesEditorScript;
